import { render, staticRenderFns } from "./OrderTableItemView.html?vue&type=template&id=35c30e9e&scoped=true&external"
import script from "./OrderTableItemView.js?vue&type=script&lang=js&external"
export * from "./OrderTableItemView.js?vue&type=script&lang=js&external"
import style0 from "@/applications/scrum/components/TrackerDataTable/TrackerDataTableView/TrackerDataTableView.css?vue&type=style&index=0&id=35c30e9e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c30e9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
installComponents(component, {VCard})
